export default {
  state: {
    objetoErro: {
      mostrarErro: false,
      titulo: "Oops, algo deu errado.",
      codigoErro: -1,
      mensagemErro: ""
    },
    callbackAbrirErro: null,
    callbackFecharErro: null
  },
  actions: {
    async criarErroGenerico({ commit, dispatch }, err) {
      commit("setLoadingModal", false);
      if (err.cancelado) {
        return {
          cancelado: true
        };
      }
      if (err.naoMostrar) {
        return;
      }
      let objetoErro = {};
      if (err.response) {
        if (err.response.status === 500) {
          objetoErro = {
            mostrarErro: true,
            codigoErro: err.response.status,
            mensagemErro: err.response.data
              ? err.response.data.message
              : "Ocorreu algum erro no sistema."
          };
        } else if (err.response.status === 401) {
          objetoErro = {
            mostrarErro: true,
            codigoErro: err.response.status,
            mensagemErro: "Ocorreu um erro de autenticação. tente novamente"
          };
          dispatch("resetarLocalStorage");
        } else if (err.response.status === 403) {
          objetoErro = {
            mostrarErro: true,
            codigoErro: err.response.status,
            mensagemErro: "Falta de papeis para ações específicas."
          };
        } else {
          let message = err.response.data;
          if (err.response.data instanceof Blob) {
            message = await err.response.data.text();
          }
          objetoErro = {
            mostrarErro: true,
            codigoErro: err.response.status,
            mensagemErro: err.response.data.message
              ? err.response.data.message
              : message
          };
        }
        commit("setErro", objetoErro);
      }
      return err;
    }
  },
  mutations: {
    setErro(state, objetoErro) {
      state.objetoErro = {
        ...state.objetoErro,
        ...objetoErro
      };
      const { mostrarErro } = objetoErro;

      if (mostrarErro && state.callbackAbrirErro !== null) {
        state.callbackAbrirErro();
      } else if (!mostrarErro && state.callbackFecharErro !== null) {
        state.callbackFecharErro();
      }
    },
    setCallbackAbrirErro(state, _callback) {
      state.callbackAbrirErro = _callback;
    },
    setCallbackFecharErro(state, _callback) {
      state.callbackFecharErro = _callback;
    },
    setLimparCallbacksErro(state) {
      state.callbackAbrirErro = null;
      state.callbackFecharErro = null;
    }
  },
  getters: {
    objetoErro: state => state.objetoErro
  }
};
